import {
  Input,
  InputGroup,
  InputRightElement,
  Spinner,
} from "@chakra-ui/react";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import { HiCheckCircle } from "react-icons/hi";
import { MdErrorOutline } from "react-icons/md";
import { useField } from "../../../hooks/FormGeneratorHooks";
import { userAtom } from "../../../state/auth";
import { FormGroup } from "./FormGroup";
import { visteAtom } from "../../../state/visteAtom";
export const FieldInput = (props) => {
  const {
    errorMessage,
    id,
    isValid,
    isSubmitted,
    isValidating,
    resetKey,
    setValue,
    value,
    errorMessages,

    otherProps,
  } = useField(props);

  const { required, name } = props;
  const [user] = useAtom(userAtom);
  const { children, label, type, placeholder, helper, ...rest } = otherProps;
  const [isTouched, setIsTouched] = useState(false);
  const [isValidation, setIsValidation] = useState(false);
  const showError = !isValid && (isTouched || isSubmitted);
  const [formData] = useAtom(visteAtom);

  useEffect(() => {
    setValue(props.value);
  }, [props.value, setValue]);

  useEffect(() => {
    setIsTouched(false);
  }, [resetKey]);

  const formGroupProps = {
    errorMessage,
    helper: isTouched ? helper : "",
    id,
    isRequired: !!required,
    label,
    showError,
    name,

    ...rest,
  };

  return (
    <FormGroup {...formGroupProps}>
      {/* { !props.isPreview && (
         <p className="text-xs text-red-300">
           {" "}
           {!isValid && !isValidation && errorMessages && errorMessages[0]}
         </p>
        )} */}
      <InputGroup>
        {rest.hasUnit && rest.hasUnit?.active && (
          <InputRightElement
            className="p-0.5 text-xs "
            fontSize={12}
            w={"auto"}
          >
            {rest.hasUnit.unit}
          </InputRightElement>
        )}

        <Input
          borderWidth={props.readOnly ? 2 : 1}
          disabled={props.readOnly ? props.readOnly : false}
          type={type || "text"}
          id={id}
          value={value ? value : (props.value ?? "")}
          onChange={(e) => {
            setIsValidation(true);
            setValue(e.target.value);
          }}
          onBlur={(e) => {
            setIsTouched(true);
            setIsValidation(false);
            if (props?.onSumbit)
              props?.onSumbit({
                fieldName: name,
                value: e.target.value,
                isValid: isValid,
              });

            //setIsTouched(false);
          }}
          fontSize="14px"
          _invalid={{ borderColor: "Red" }}
          className=" focus:border-blue-500 focus:shadow-sm w-full "
          aria-invalid={showError}
          aria-describedby={!isValid ? `${id}-error` : undefined}
          placeholder={placeholder}
        />
      </InputGroup>
      {!props?.isPreview && user?.type === "writer" && (
        <div className="absolute -left-8 top-1/2">
          {" "}
          {isValidation && (
            <p>
              <Spinner size="sm" flex="none" color="blue.200" />
            </p>
          )}
          <p>
            {" "}
            {isValid && !isValidation && (
              <HiCheckCircle color="#67d428" width={20} height={20} />
            )}
            {!isValid && !isValidation && (
              <MdErrorOutline color="#ff0000" width={20} height={20} />
            )}
          </p>
        </div>
      )}

      {children}
    </FormGroup>
  );
};
